export var FieldType;
(function (FieldType) {
    FieldType["string"] = "String";
    FieldType["email"] = "Email";
    FieldType["creditCardNumber"] = "CreditCardNumber";
    FieldType["creditCardExpirationDate"] = "CreditCardExpirationDate";
    FieldType["iban"] = "IBAN";
    FieldType["file"] = "File";
    FieldType["amount"] = "Amount";
    FieldType["checkbox"] = "Checkbox";
    FieldType["dropdown"] = "Dropdown";
    FieldType["number"] = "Number";
    FieldType["phone"] = "Phone";
    FieldType["terms"] = "Terms";
})(FieldType || (FieldType = {}));
